import dayjs from 'dayjs';
import api from '@/helpers/api'

const API_READ=`/api/voucher_redeem/`
const API_UPDATE=API_READ
const API_CREATE=API_READ
const API_DELETE=API_READ


export default {
    namespaced:true,
    state: {
        status: '',
        voucherRedeems:[],
        currUser: {},
        errMessage: '',
        meta:{
            page:1,
            limit:10,
            total:1
        },
        filter: {},
        search: {},
        // State untuk menyimpan posisi dan data
        savedState: {
            scrollPosition: 0,
            filter: {},
            search: {},
            meta: {
                page: 1,
                limit: 10,
                total: 1
            },
            searchOptions: '',
            sortOptions: '',
            sortDesc: true,
            claimedVoucher: false,
            searchKeyword: '',
            dateRange: [null, null]
        }
    },
    mutations: {
        request(state){
            state.status = 'loading'
        },
        success(state){
            state.status = 'success'
        },
        error(state){
            state.status = 'error'
        },
        read(state, {voucherRedeems}){
            state.voucherRedeems = [...voucherRedeems]
        },
        read_single_success(state, {voucherRedeems}){
            state.voucherRedeems = voucherRedeems
        },
        switch_page(state,{meta}){
            state.meta={...meta}
        },
        add_filter(state, {filter}) {
            state.filter = {...filter};
        },
        set_search(state, {search}){
            state.search = {...search};
        },
        clear_search(state){
            state.search = {};
        },
        clear_filter(state){
            state.filter = {};
            state.meta = {
                page:1,
                limit:10,
                total:1
            };
        },
        clear_meta(state){
            state.meta = {
                page:1,
                limit:10,
                total:1
            };
        },
        // Mutations untuk menyimpan dan memulihkan state
        save_state(state, { savedState }) {
            state.savedState = { ...savedState };
        },
        restore_state(state) {
            state.filter = { ...state.savedState.filter };
            state.search = { ...state.savedState.search };
            state.meta = { ...state.savedState.meta };
        },
        clear_saved_state(state) {
            state.savedState = {
                scrollPosition: 0,
                filter: {},
                search: {},
                meta: {
                    page: 1,
                    limit: 10,
                    total: 1
                },
                searchOptions: '',
                sortOptions: '',
                sortDesc: true,
                claimedVoucher: false,
                searchKeyword: '',
                dateRange: [null, null]
            };
        }
    },
    actions: {
        read({commit, state}){

            commit('request');

            const {meta} = state
            const { filter } = state
            const { search } = state

            return new Promise((resolve, reject) => {
                api.request('get', API_READ, {meta, filter, search})
                .then((result) => {
                    const currentDate = new Date();
                    const vouchers = result.data.data;

                    vouchers.forEach(voucher => {
                        const expiredAtDate = new Date(voucher.expired_at);
                        if (voucher.cancelled_at !== null) {
                            voucher.cancelled_status = 'cancelled';
                        }
                        voucher.expired_status = expiredAtDate < currentDate ? 'expired' : 'N/A';
                    });

                    commit('success')
                    commit('read',{voucherRedeems:result.data.data})
                    commit('switch_page',{meta:{...result.data.meta}})
                    return resolve(result)
                }).catch((err) => {
                    commit('error', {message: err})
                    return reject(err);
                });
            });
        },
        read_single({commit},id){

            commit('request');

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}${id}`)
                .then((result) => {            
                    commit('success')
                    return resolve(result.data.data);
                }).catch((err) => {
                    commit('error', {message: err});
                    return reject(err);
                });
            })
        },
        delete({commit, dispatch},id){
            
            commit('request');
            
            return new Promise((resolve, reject) => {
                api.request('delete', `${API_DELETE}${id}`)
                .then((response) => {
                    dispatch('read');
                    commit('success');
                    return resolve(response.data)
                }).catch((err) => {
                    commit('error', {message: err})
                    return reject(err.response.data)
                });
            })
        },
        update({commit},{data}){

            commit('request');

            data.claimed_at = dayjs(new Date()).format('YYYY-MM-DDTHH:mm')

            return new Promise((resolve, reject) => {
                api.request('put', `${API_UPDATE}${data.id}`, {}, data)
                .then((request) => {
                    commit('success');
                    return resolve(request)
                }).catch((err) => {
                    commit('error', {message: err})
                    return reject(err)
                });
            });
        },
        create({commit},{data}){
            
            commit('request');

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                .then((request) => {
                    commit('success');
                    return resolve(request)
                }).catch((err) => {
                    commit('error', {message: err})
                    return reject(err)    
                });
            });
        },
        claim({commit},{data}){

            commit('request');

            data.claimed_at = dayjs(new Date()).format('YYYY-MM-DDTHH:mm')

            return new Promise((resolve, reject) => {
                api.request('post', API_CREATE, {}, data)
                .then((request) => {
                    commit('success');
                    return resolve(request)
                }).catch((err) => {
                    commit('error', {message: err})
                    return reject(err)    
                });
            });
        },
        export({ commit, state }) {

            commit('request');

            const { meta } = state
            const { filter } = state
            const { search } = state

            return new Promise((resolve, reject) => {
                api.request('get', `${API_READ}export`, { meta, filter, search }, { responseType: 'blob' })
                    .then((result) => {
                        return resolve(result);
                    }).catch((err) => {
                        const errorMessage = err.response?.data?.error || err.response?.data?.message || 'Something went wrong';
                        return reject({ error: errorMessage });
                    });
            });
        },
    },
    getters : {
    voucherRedeems: ()=>state => state.voucherRedeems,
    }
}
